import React from "react";
import style from "./index.module.scss";
import { Button, Popover } from "antd";
import {
    createNumberCode,
    createPlain,
    signInEnd,
    SignStatus,
    SignType
} from "service/signIn";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";

interface OperateProps {
    signType: SignType; // 0：二维码 1：数字 2：普通
    className?: string;
    refObj: React.RefObject<HTMLDivElement>;
    state: number;
    signId: number;
    onDelete: () => void;
    onSetting: () => void;
    onEnd?: () => void;
    gotoDetail: (signInId: number, params?: StringMap) => void;
    mode?: "projection" | "normal"; // 投屏还是非投屏
}

export default function Operate({
    className,
    refObj,
    state,
    signType,
    signId,
    onDelete,
    onEnd,
    onSetting,
    gotoDetail,
    mode
}: OperateProps) {
    const popover = (
        <div className={style.popover}>
            <button onClick={onSetting}>设置</button>
            <button onClick={onDelete}>删除</button>
        </div>
    );

    // 开始签到
    const onStart = usePromiseCallback(async function () {
        try {
            if (signType === SignType.Normal) {
                await createPlain(signId);
            }

            if (signType == SignType.Number) {
                await createNumberCode(signId);
            }

            gotoDetail(signId);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    });

    // 结束签到
    const onEndClick = usePromiseCallback(async function () {
        try {
            await signInEnd(signId);
            gotoDetail(signId);
            onEnd?.();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    });

    return (
        <div className={`${style.root} ${className}`}>
            <div className={style.wrapper}>
                {state === SignStatus.Idle && (
                    <Button
                        className={style.item}
                        onClick={onStart}
                        type="link">
                        开始签到
                    </Button>
                )}
                {state === SignStatus.InProgress && (
                    <Button
                        className={style.item}
                        onClick={() => gotoDetail(signId)}
                        type="link">
                        进入活动
                    </Button>
                )}
                {state === SignStatus.InProgress && (
                    <Button
                        className={style.item}
                        onClick={onEndClick}
                        type="link">
                        结束签到
                    </Button>
                )}
            </div>

            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}
                getPopupContainer={() => refObj.current!}>
                <button className={style.more} />
            </Popover>
        </div>
    );
}

Operate.defaultProps = {
    state: "0"
};
